import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
import SuccessErrorMsg from "../utilities/SuccessErrorMsg";
import { ReCaptchaHidden } from '../utilities/ReCaptchaForForms';
import { emailValidation, mobileValidation } from '../utilities/validations/inputsValidations';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useLangUrl } from '../utilities/useLangUrl';

export default function Register() {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const navigate = useNavigate();
    const [, setLoading] = useState(false);
    const { t, i18n } = useTranslation();
    const langUrl = useLangUrl();

    async function onSubmit(data) {
        setLoading(true);
        console.log("Form data: ", data); // Debug: Check form data
        try {
            let loginData = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/auth/register`, {
                method: "POST",
                headers: {
                    "accept": "*/*",
                    "Content-Type": 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (loginData.ok) {
                // setSuccess(true)
                toast.success(t("Active Link"))

                // changed by github copilot as it was not used (has no effect / Useless assignment to local variable) (to verify)
                // loginData = await loginData.json();

                setTimeout(() => {
                    navigate('/logIn');
                }, 5000);

                // Redirect to another page after successful submission
            } else if (loginData.status === 401 || loginData.status === 400) {
                toast.warn(t("errorRegister"))

            } else {
                toast.error(t("errorTryAgain"), loginData.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            toast.warn(t("errorGetSupport"));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='dashboard d-flex flex-row'>
            <div className='dashboard-form container col-12 col-md-6 mx-auto my-auto px-4 px-md-5 text-start'>
                <h4 className='c-darkOrange'>{t("register")}</h4>
                <form className='d-flex flex-column w-75 mx-auto my-5 gap-2 text-start' onSubmit={handleSubmit(onSubmit)}>
                    {i18n.language === "ar" ?
                        <p className='text-info'>بالتسجيل في المنصة فأنت توافق على <a className='text-warning text-decoration-none' href={`${langUrl}/policy`}>سياسة الخصوصية</a></p> :
                        <p className='text-info'>By registering on the platform, you agree to the <a className='text-warning text-decoration-none' href={`${langUrl}/policy`}>Privacy Policy</a></p>
                    }
                    <input className={`form-control ${errors.firstName && "border border-danger"}`} type="text"
                        placeholder={t("firstName")} {...register("firstName", { required: true, minLength: 3 })} />
                    {errors.firstName && <p className='errors-msg'>{t("errorNameShort")}</p>}
                    <input className={`form-control ${errors.lastName && "border border-danger"}`} type="text"
                        placeholder={t("lastName")} {...register("lastName", { required: true, minLength: 3 })} />
                    {errors.lastName && <p className='errors-msg'>{t("errorNameShort")}</p>}

                    <input className={`form-control ${errors.email && "border border-danger"}`} type="email" placeholder={t("Email")} {...register("email", { required: true, pattern: emailValidation })} />
                    {errors.email && <p className='errors-msg'>{t("errorEmail")}</p>}

                    <input className={`form-control ${errors.mobilePhone && "border border-danger"}`} type="tel" placeholder="05xxxxxxxx" {...register("mobilePhone", { required: true, minLength: 10, pattern: mobileValidation })} />
                    {errors.mobilePhone && <p className='errors-msg'>{t("errorPhone")}</p>}

                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" defaultChecked={true}
                            onChange={e => setValue("contactViaEmail", true)}
                            // onChange={e => setValue("contactViaEmail", e.target.checked)}
                            id="contactViaEmail"
                        // {...register("contactViaEmail", { required: false })}
                        />
                        {i18n.language === "ar" ?
                            <label className="form-check-label" htmlFor="contactViaEmail">
                                أرسل لي تحديثات المنصة عبر البريد الالكتروني
                            </label> :
                            <label className="form-check-label" htmlFor="contactViaEmail">
                                Send me updates via email
                            </label>
                        }
                    </div>
                    <a className='text-secondary' href={`${langUrl}/logIn`}>{t("HaveAccount")}</a>

                    <div className="align-self-end">
                        <ReCaptchaHidden />
                    </div>

                    <input className='btn btn-light-beige text-white' type="submit" value={t("Send")} />
                </form>
                <SuccessErrorMsg
                    ToastContainer={ToastContainer}
                />
            </div>
            <div className='d-none d-sm-block col-6 bg-light-beige'>
            </div>
        </div>

    )
}
